import {
  AutoComplete,
  AutoCompleteMulti,
  ISelectType,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { calendarRegisterList } from "../../../../../../../../services/ticketAutomationReceivedSlotCalendar.service";
import { useTranslation } from "react-i18next";
import { IAgendasProps } from "../models";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationRecRuleTicketDefDoc.";

export const Agendas = memo(({ automationCode }: IAgendasProps) => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(calendarRegisterList);

  const [
    ticketAutRecRuleTicketDefDocsCalendarsOptions,
    setTicketAutRecRuleTicketDefDocsCalendarsOptions,
  ] = useState<ISelectType[]>([]);

  const tasyScheduleTypeCode = useMemo(() => {
    if (!automationCode) return;

    switch (automationCode) {
      case "21":
        return 2;
      default:
        return 3;
    }
  }, [automationCode]);

  const params = useMemo(() => {
    return {
      EnableCode: true,
      TasyScheduleTypeCode: tasyScheduleTypeCode,
    };
  }, [tasyScheduleTypeCode]);

  const fetchticketAutRecRuleTicketDefDocsCalendars = useCallback(async () => {
    const { data, success } = await sendRequest(params);

    if (data && success) {
      const isType3Selected = tasyScheduleTypeCode === 3;

      setTicketAutRecRuleTicketDefDocsCalendarsOptions(
        data.map((d) => {
          const titleBase = isType3Selected
            ? d.descriptionSite ?? d.calendarName
            : d.calendarName;

          return {
            id: String(d.identifier),
            name: `${titleBase} - ${d.identifier}`,
          };
        })
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchticketAutRecRuleTicketDefDocsCalendars();
  }, [fetchticketAutRecRuleTicketDefDocsCalendars]);

  return (
    <Grid item xs={12}>
      <AutoCompleteMulti
        fullWidth
        options={ticketAutRecRuleTicketDefDocsCalendarsOptions}
        name="ticketAutRecRuleTicketDefDocsCalendars"
        label={t(translationPath + "ticketAutRecRuleTicketDefDocsCalendars")}
        getOptionLabel={(option) => option.name}
        size="small"
        keepOpenOnSelect={true}
      />
    </Grid>
  );
});

// se for Tasy Agenda Exames - Agendar, TasyScheduleTypeCode = 2
// se não, TasyScheduleTypeCode = 3
